module.exports = __webpack_public_path__ + "img/2.ec8a73e3.svg";